/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Product {
    /**
     * name of product
     */
    name?: string;

    /**
     * globally unique id
     */
    id?: string;

    /**
     * type of product
     */
    type?: Product.Type;

    /**
     * tag Id
     */
    tagId?: string;

    /**
     * description of product
     */
    description?: string;

    /**
     * created by user id
     */
    createId?: string;

    /**
     * created timestamp
     */
    createAt?: string;

    /**
     * last updated timestamp
     */
    updateAt?: string;

    /**
     * last updated by user id
     */
    updateId?: string;

    /**
     * accounting code for Great Plains export
     */
    accountingCode?: string;

    /**
     * unique sku
     */
    sku?: string;

    /**
     * current price
     */
    price?: number;

    /**
     * learning program
     */
    isLearningProgram?: boolean;

    /**
     * learning program text
     */
    isLearningProgramText?: string;

    wcProductId?: string;
}

export namespace Product {

    export enum Type {
        NORMAL = <any>'NORMAL',
        DUES = <any>'DUES',
        LOCATIONS = <any>'LOCATIONS',
        CERT_NEW = <any>'CERT_NEW',
        CERT_RENEW = <any>'CERT_RENEW',
        WIKI = <any>'WIKI',
        BADGE = <any>'BADGE',
        GLOBALCONNECT = <any>'GLOBALCONNECT',
        WOOCOMMERCE = <any>'WOOCOMMERCE',
        LEARNING = <any>'LEARNING',
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/Product.ts